<div class="dialog-header">
    <h2>Recall Contract</h2>
    <ng-icon name="heroXMark" mat-dialog-close class="cursor-pointer"></ng-icon>
</div>
<form [formGroup]="recallForm" (ngSubmit)="onConfirm()">
    <mat-dialog-content>
        <p>Are you sure you want to recall this contract? This action will void the envelope and cannot be undone.</p>
        <p>Please provide a reason for recalling:</p>
        <div class="w-100 recall-form">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Void Reason</mat-label>
                <textarea matInput formControlName="voidReason" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="3" cdkAutosizeMaxRows="8" [errorStateMatcher]="matcher" 
                    placeholder="Enter the reason for recalling this contract"></textarea>
                <mat-error *ngIf="recallForm.get('voidReason').hasError('required')">
                    Void Reason is required
                </mat-error>
            </mat-form-field>
        </div>
    </mat-dialog-content>
    <mat-divider></mat-divider>
    <mat-dialog-actions align="end">
        <button mat-raised-button type="button" (click)="onCancel()" color="primary"
            class="outlined-btn">Cancel</button>
        <button color="warn" mat-raised-button class="ml-3" [disabled]="isLoading || !recallForm.valid" type="submit">
            Recall
            <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
        </button>
    </mat-dialog-actions>
</form>

